module.exports = __webpack_public_path__ + "media/categories/23-8296612d.svg";